module.exports = "<div class=dropdown uib-dropdown auto-close=outsideClick> <button class=\"form-control btn-dropdown\" type=button uib-dropdown-toggle> <span class=pull-right> <span class=caret></span> </span> <span translate>Add filters...</span> </button> <div class=dropdown-menu uib-dropdown-menu> <app-checkbox ng-repeat=\"box in $ctrl.filters | filter:{optional: true}\" field=box.active label=\"{{ box.label | translate }}\"></app-checkbox> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/searchfilters/selector/partial.html
// module id = 527
// module chunks = 0